/**
 * Heuristic: discovery option suggests mutating / creating resources (disable when read-only admin).
 */
export function isCreateLikeDiscoveryOption(opt) {
  if (!opt) return false;
  const t = `${opt.label || ""} ${opt.description || ""}`.toLowerCase();
  return /\b(create|provision|push|deploy|write|register|add group|new group|delete|remove)\b/i.test(t);
}
